export default __webpack_public_path__ + "static/media/watsapp.c826b016.png";